// Subscription constants shared by the pages and the server (no server-only
// imports here — the service page bundles this file). Server side:
// lib/subscription.js.

export const SUBSCRIPTION_PRICE        = "$9.99";
export const SUBSCRIPTION_PRICE_AMOUNT = 9.99;
export const SUBSCRIPTION_TITLE        = "Unlimited Instant Graphics";
export const SUBSCRIPTION_TAG          = "rg-subscription";
